import { type GetHookResponse } from '../hooks'
import { timeslotsKey } from '../keys'
import { useTantalimQuery } from '../query'
import { useUserCache } from '../user'
import {
  HOUR,
  type TinyCloser,
  MINUTE,
  type CalendarTimeslotsInput,
  type CalendarTimeslotsSuccess,
} from '@terros/common'

export function useTimeslots(input: CalendarTimeslotsInput = {}): GetHookResponse<TinyCloser[]> {
  const cache = useUserCache()
  return useTantalimQuery<CalendarTimeslotsInput, CalendarTimeslotsSuccess, TinyCloser[]>({
    url: '/calendar/timeslots',
    queryKey: timeslotsKey(input),
    input,
    convertResponse: ({ closers }) => {
      closers.forEach((closer) => cache.setTinyUser(closer.user))
      return closers
    },
    options: {
      gcTime: HOUR,
      staleTime: MINUTE,
    },
  })
}
